import React from "react";
import { ThemeProvider } from "@mui/material";
import { StylesProvider } from "@mui/styles";
import { themeSettings } from "./themeSettings";

const ThemeProviderWrapper = ({ children }) => {
  return (
    <StylesProvider injectFirst>
      <ThemeProvider theme={themeSettings}>{children}</ThemeProvider>
    </StylesProvider>
  );
};

export default ThemeProviderWrapper;
